<template>
  <v-list class="py-0 px-3">
    <b>Prices</b>
    <v-row no-gutters class="my-2">
      <v-col>
        <QButtonGroup v-model="detail.PriceModelId" label="Price model" :list="priceModelOptions" :edit="true" dense
          noempty>
        </QButtonGroup>
      </v-col>
    </v-row>

    <!-- Price model per month -->
    <template v-if="detail.PriceModelId == PriceModels.PerMonth.value">
      <v-row v-for="(price, index) in detail.ContractPrices" :key="'price-row' + index" no-gutters>
        <v-col>
          <QDateField3 v-model="price.PriceDate" :key="detail.ContractPrices.length + '-' + index" label="Date"
            :min="null" :max="null" externaledit>
          </QDateField3>
        </v-col>
        <v-col class="px-3">
          <QTextField v-model="price.NewPrice" :key="detail.ContractPrices.length + '_' + index" label="Price"
            externaledit :prefix="moneySign" reverse :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
        <!-- OPTION B: Discount per timed price -->
        <!--
        <v-col cols="auto" style="width: 65px;" class="pr-3">
          <QTextField v-model="price.Discount" label="Discount" externaledit prefix="%" reverse
            :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
        -->
        <SpecialDeleteButton :deleteFunc="() => handleDeletePrice(price)" :roundTop="index == 0"
          :roundBottom="index == (detail.ContractPrices.length - 1)">
        </SpecialDeleteButton>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <QDateField3 v-model="newMontlyPriceItem.PriceDate" :key="detail.ContractPrices.length + '--'" label="Date"
            :min="null" :max="null" externaledit>
          </QDateField3>
        </v-col>
        <v-col class="px-3">
          <QTextField v-model="newMontlyPriceItem.NewPrice" :key="detail.ContractPrices.length + '__'" label="Price"
            externaledit :prefix="moneySign" reverse :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
        <!-- FOR OPTION B: Discount per timed price
        <v-col cols="auto" style="width: 65px;" class="pr-3">
        </v-col>
        -->
        <v-col cols="auto" style="width: 44px;">
        </v-col>
      </v-row>
      <!-- OPTION A: Discount row across all timed prices -->
      <v-row no-gutters>
        <v-col class="pr-3 mt-3">
          <QTextField v-model="detail.ContractDetailArticleDiscount" label="Discount" externaledit prefix="%" reverse
            :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
        <v-col cols="auto" style="width: 44px;">
        </v-col>
      </v-row>
    </template>

    <!-- Price model per unit -->
    <template v-else>
      <v-row no-gutters>
        <v-col class="pr-3">
          <QTextField v-model="detail.Price" label="Price" externaledit :prefix="moneySign" reverse :rules="[floatRule]"
            placeholder="0">
          </QTextField>
        </v-col>
        <v-col>
          <QTextField v-model="detail.ContractDetailArticleDiscount" label="Discount" externaledit prefix="%" reverse
            :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col class="pr-3">
          <QTextField v-model="detail.HighPrice" label="HighPrice" externaledit :prefix="moneySign" reverse
            :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
        <v-col>
          <QTextField v-model="detail.LowPrice" label="LowPrice" externaledit :prefix="moneySign" reverse
            :rules="[floatRule]" placeholder="0">
          </QTextField>
        </v-col>
      </v-row>

      <v-list class="py-4">
        <b>Consumptions</b>
        <v-list-item v-for="(consumption, index) in detail.ContractDetailConsumptions" :key="'consumption-' + index"
          class="px-0">
          <QDateField3 v-model="consumption.Date" label="Date" :min="null" :max="null" externaledit class="pr-3">
          </QDateField3>
          <QTextField v-model="consumption.Qty" label="Qty" externaledit prefix="x" reverse :rules="[floatRule]">
          </QTextField>
        </v-list-item>
        <v-list-item class="px-0">
          <QDateField3 v-model="newConsumption.Date" label="Date" :min="null" :max="null" externaledit class="pr-3">
          </QDateField3>
          <QTextField v-model="newConsumption.Qty" label="Qty" externaledit prefix="x" reverse :rules="[floatRule]">
          </QTextField>
        </v-list-item>
      </v-list>
    </template>
  </v-list>
</template>


<script>
import ContractDetailConstants from '@/helpers/Constants/ContractDetailConstants';
import QDateField3 from "@/components/Inputs/QDateField3.vue";
import SpecialDeleteButton from "./SpecialDeleteButton.vue";

export default {
  name: "ContractDetailPriceControl",
  model: {
    prop: 'detail',
    event: 'input'
  },
  props: {
    detail: Object,
  },
  components: {
    QDateField3,
    SpecialDeleteButton,
  },
  mixins: [],

  data() {
    return {
      PriceModels: ContractDetailConstants.PriceModels,
      // Draft rows, included into arrays only when valid
      newMontlyPriceItem: {
        ContractDetailId: this.detail?.Id ?? null,
        Id: 0,
        PriceDate: null,
        NewPrice: null,
      },
      newConsumption: {
        ContractDetailId: this.detail?.Id ?? null,
        Id: 0,
        Date: null,
        Invoiced: null,
        Qty: null,
      },
    };
  },

  methods: {
    ensureArraysExist() {
      if (!this.detail.ContractPrices) {
        this.$set(this.detail, 'ContractPrices', []);
      }
      if (!this.detail.ContractDetailConsumptions) {
        this.$set(this.detail, 'ContractDetailConsumptions', []);
      }
    },

    isValidMonthlyPrice(item) {
      return !!item?.PriceDate;
    },

    isValidConsumption(item) {
      return !!item?.Date;
    },

    pushMonthlyPriceIfValid() {
      this.ensureArraysExist();
      if (this.isValidMonthlyPrice(this.newMontlyPriceItem)) {
        const toAdd = {
          ContractDetailId: this.detail?.Id ?? null,
          Id: 0,
          PriceDate: this.newMontlyPriceItem.PriceDate,
          NewPrice: this.newMontlyPriceItem.NewPrice ?? 0,
        };
        this.detail.ContractPrices.push(toAdd);
        // reset draft
        this.newMontlyPriceItem = {
          ContractDetailId: this.detail?.Id ?? null,
          Id: 0,
          PriceDate: null,
          NewPrice: null,
        };
      }
    },

    pushConsumptionIfValid() {
      this.ensureArraysExist();
      if (this.isValidConsumption(this.newConsumption)) {
        const toAdd = {
          ContractDetailId: this.detail?.Id ?? null,
          Id: 0,
          Date: this.newConsumption.Date,
          Invoiced: this.newConsumption.Invoiced ?? null,
          Qty: this.newConsumption.Qty ?? 1,
        };
        this.detail.ContractDetailConsumptions.push(toAdd);
        // reset draft
        this.newConsumption = {
          ContractDetailId: this.detail?.Id ?? null,
          Id: 0,
          Date: null,
          Invoiced: null,
          Qty: null,
        };
      }
    },

    async handleDeletePrice(price) {
      this.ensureArraysExist();
      const list = this.detail.ContractPrices || [];

      // Prefer identity match
      let idx = list.indexOf(price);

      // Fallback to Id matching (works for persisted rows)
      if (idx === -1 && price && price.Id !== undefined && price.Id !== null) {
        idx = list.findIndex(p => p.Id === price.Id);
      }

      // Last resort: shallow content match (helps when multiple unsaved items have Id=0)
      if (idx === -1 && price) {
        idx = list.findIndex(p =>
          (p.Id ?? 0) === (price.Id ?? 0) &&
          p.PriceDate === price.PriceDate &&
          (p.NewPrice ?? null) === (price.NewPrice ?? null)
        );
      }

      if (idx === -1) return;

      // Reactive removal
      list.splice(idx, 1);
    }
  },

  computed: {
    priceModelOptions() {
      return Object.values(this.PriceModels);
    },
  },

  watch: {
    // Emit input when any nested field changes so v-model syncs with parent
    detail: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    // When user completes a valid draft monthly price, append to array and reset
    'newMontlyPriceItem.PriceDate'() {
      this.pushMonthlyPriceIfValid();
    },
    'newMontlyPriceItem.NewPrice'() {
      // Price alone doesn't validate, but pushing again is harmless due to guard
      this.pushMonthlyPriceIfValid();
    },
    // When user completes a valid draft consumption, append to array and reset
    'newConsumption.Date'() {
      this.pushConsumptionIfValid();
    },
    'newConsumption.Qty'() {
      this.pushConsumptionIfValid();
    },
  },
};
</script>

<style></style>